const convertEvidenceVariableHandlingToCodeableConcept = (handling, handlingDetail) => {
    if (!handling) {
        return "";
    }
    if (typeof handling === "object") {
        return handling;
    }
    if (typeof handling === "string") {
        if (handling === "boolean") {
            return {
                "coding": [{
                    "system": "http://hl7.org/fhir/variable-handling",
                    "code": "boolean",
                    "display": "boolean variable"
                }]
            };
        } else if (handling === "continuous") {
            return {
                "coding": [{
                    "system": "http://hl7.org/fhir/variable-handling",
                    "code": "continuous",
                    "display": "continuous variable"
                }]
            };
        } else if (handling === "dichotomous") {
            return {
                "coding": [{
                    "system": "http://hl7.org/fhir/variable-handling",
                    "code": "dichotomous",
                    "display": "dichotomous variable"
                }]
            };
        } else if (handling === "polychotomous") {
            return {
                "coding": [{
                    "system": "http://hl7.org/fhir/variable-handling",
                    "code": "polychotomous",
                    "display": "polychotomous variable"
                }]
            };
        } else if (handling === "ordinal") {
            return {
                "coding": [{
                    "system": "http://hl7.org/fhir/variable-handling",
                    "code": "ordinal",
                    "display": "ordinal variable"
                }]
            };
        } else if (handling === "extension" && handlingDetail) {
            return handlingDetail;
        }
        return { "text": handling };
    }
}
export default convertEvidenceVariableHandlingToCodeableConcept;